import styled from '@emotion/styled';

export const StepSubHeadline = styled.h4({
    color: '#9a9a98',
    fontFamily: "'FT Regola Neue'",
    fontFeatureSettings: "'dlig' on, 'ss03' on",
    fontSize: '1.5rem',
    fontStyle: 'normal',
    fontWeight: 500,
    letterSpacing: '-0.03rem',
    lineHeight: '2rem',
    margin: 0,
    padding: 0,
});
